var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VFileInput',_vm._g(_vm._b({attrs:{"hide-details":"auto","clearable":!_vm.required}},'VFileInput',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }